module.exports = __webpack_public_path__ + "attachment-upload.69fcccea2191bb2c90b49820cd391525.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-upload.svg
// module id = 1127
// module chunks = 0